const request = require('airship/modules/request2')

module.exports = getJson

function getJson(url, options = {}) {
  const requestOptions = Object.assign({url}, options)

  return new Promise(makeRequest)

  function makeRequest(resolve, reject) {
    request
      .get(requestOptions)
      .then(parseResponse)
      .catch(reject)

    function parseResponse(resp) {
      if (resp.statusCode > 299 || resp.statusCode < 200) {
        const err = new Error(`${resp.statusCode} response from ${url}`)

        err.xhr = {status: resp.statusCode}

        return reject(err)
      }

      try {
        resolve(JSON.parse(resp.body))
      } catch (err) {
        reject(err)
      }
    }
  }
}
